<template>
  <div class="">
    <van-field v-model="valueStr" :required="required" @click="!disabled?showPicker=true:showPicker=false" :label="label" placeholder="请选择" :class="valueStr?'has-val':'no-val'"
               :border="false" readonly :is-link="!disabled" style="border-bottom: 0.5px solid #ebedf0;"/>
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker v-model="currentDate" show-toolbar :title="label" @cancel="showPicker = false" @confirm="onConfirm"
                           type="date" :min-date="minDate" :max-date="maxDate"/>
    </van-popup>
  </div>
</template>
<script>
import { DatetimePicker, Popup, Field } from 'vant'

export default {
  name: 'date-pick',
  components: {
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Field.name]: Field
  },
  data () {
    return {
      showPicker: false,
      currentDate: new Date(),
      minDate: new Date(1940, 0, 1),
      maxDate: new Date(2100, 0, 1),
      valueStr: ''
    }
  },
  props: {
    value: {
      type: [String, Date],
      default: ''
    },
    label: {
      type: String,
      default: 'label'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  created () {
    if (this.value) {
      this.valueStr = this.$moment(this.value).format('YYYY.MM.DD')
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  destroyed () {
  },
  methods: {
    onConfirm (date) {
      this.showPicker = false
      this.valueStr = this.$moment(date).format('YYYY.MM.DD')
      this.$emit('change', date)
    }
  },
};
</script>
<style>
</style>
